export const s = {
  button: `px-8 py-4 uppercase text-clamp-md text-white bg-impred rounded border border-solid border-impred curser-pointer lgx:px-6`,
}
